import React from 'react';
import {useTranslation} from 'react-i18next';

interface QuestionReportRespondentsProps {
    count: number;
}

function QuestionReportRespondents({count}: QuestionReportRespondentsProps): JSX.Element {
    const {t} = useTranslation();

    return (
        <div className="c-questionsAnsweredCount c-questionsAnsweredCount--twoLabels">
            <span className="c-questionsAnsweredCount__label">
                {count} {t('slide.questionCounter.respondents', {count})}
            </span>
        </div>
    );
}

export default QuestionReportRespondents;
